<ng-container *ngIf="view && seconds < estimate && percent <= 100">
  <div class="d-flex align-items-center flex-row gap-6">
    <div [style.width]="circle.width">
      <circle-progress
        [percent]="percent"
        [radius]="circle.radius"
        [outerStrokeColor]="'#007a79'"
        [outerStrokeWidth]="6"
        [animation]="true"
        [startFromZero]="false"
        [animationDuration]="300"
        [responsive]="true"
        [showTitle]="true"
        [showUnits]="true"
        [showSubtitle]="false"
        [showInnerStroke]="false"
        [titleFontSize]="circle.titleFontSize"
        [unitsFontSize]="circle.unitsFontSize"
      ></circle-progress>
    </div>
    <div class="d-flex flex-column text-center">
      <span>{{ "loading-time.estimated-time" | translate }} {{estimate}} {{ "loading-time.seconds" | translate }}.</span>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="view && seconds >= estimate && seconds <= estimate + 5 && percent <= 100">
  <div class="d-flex align-items-center flex-row gap-6">
    <div [style.width]="circle.width">
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border spinner-primary"
          [style.width]="circle.width"
          [style.height]="circle.width"
          style="color: #007a79; border-width: 3px"
          role="status"
        >
          <span class="sr-only">{{ "general.loading" | translate }}...</span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column text-center">
      <span>{{ "loading-time.taking-longer" | translate }}</span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="view && seconds >= estimate + 5 && percent <= 100">
  <div class="d-flex align-items-center flex-row gap-6">
    <div [style.width]="circle.width">
      <div class="d-flex justify-content-center position-relative">
        <div
          class="spinner-border spinner-primary"
          [style.width]="circle.width"
          [style.height]="circle.width"
          style="color: #ffcc00; border-width: 3px"
          role="status"
        >
          <span class="sr-only">{{ "general.loading" | translate }}...</span>
        </div>
        <i
          class="fa fa-exclamation"
          aria-hidden="true"
          style="position: absolute; top: 36%; color: #ffcc00"
        ></i>
      </div>
    </div>
    <div class="d-flex flex-column text-center">
      <span>{{ "loading-time.taking-longer-check-connection" | translate }}</span>
    </div>
  </div>
</ng-container>
